module.exports = __webpack_public_path__ + "img/32.dc5275dc.jpg";